module.exports = __webpack_public_path__ + "img/mappa.46c3f311.png";